import React, { useRef } from 'react';
import ImageOverlayCard from './ImageOverlayCard';
import Empower from '../../assets/Workwithus/1.Empower.jpg';
import Transform from '../../assets/Workwithus/2.Transform.jpg';
import Dedication from '../../assets/Workwithus/3.Dedication.jpg';
import Probono from '../../assets/Workwithus/4.Probono.jpg';
import '../../styles/WorkWithUs.css';
import useDragToScroll from '../../hooks/useDragToScroll';

const cardData = [
  {
    image: Empower,
    title: 'Empower Individuals and Families',
    description:
      'At JS Property, our purpose is to empower individuals and families by providing comprehensive real estate solutions that encompass asset progression, property transactions, investment strategies, and portfolio management.',
  },
  {
    image: Transform,
    title: 'Transform Lives with Exceptional Service',
    description:
      'Our mission is to transform lives by delivering exceptional service, fostering financial well-being, and creating opportunities for a secure and prosperous future.',
  },
  {
    image: Dedication,
    title: 'Dedication to Supporting Clients',
    description:
      'This purpose statement reflects our dedication to not only facilitating property transactions but also supporting our clients through life\'s challenges, ensuring they achieve their real estate goals with confidence and ease.',
  },
  {
    image: Probono,
    title: 'Offering Pro-Bono Services',
    description:
      'We are committed to offering Pro-Bono services to those facing financial challenges, guiding and assisting clients through the complexities of buying, selling, or renting their homes, especially during personal hardships.',
    link: '/pro-bono',
  },
];

const PurposeSection = () => {
  const sliderRef = useRef();
  useDragToScroll(sliderRef);

  return (
    <section className='innerSection'>
      <h2>Our Purpose</h2>
      <div className="cardSlider" ref={sliderRef}>
        {cardData.map((card, index) => (
          <ImageOverlayCard
            key={index}
            image={card.image}
            title={card.title}
            description={card.description}
            link={card.link}
          />
        ))}
      </div>
    </section>
  );
};

export default PurposeSection;
